module.exports = __webpack_public_path__ + "assets/img/status-attention-wcag.02da180d.svg";